import {ELocationStateKey, useAppHistory} from 'shared/hooks/use-app-history';

import {IBreadcrumbItem} from '../breadcrumb';

interface IUseLocationStateBreadcrumbsArgs {
    breadcrumbs?: IBreadcrumbItem[];
}

type TUseLocationStateBreadcrumbs = (args: IUseLocationStateBreadcrumbsArgs) => IBreadcrumbItem[] | null;

export const useLocationStateBreadcrumbs: TUseLocationStateBreadcrumbs = ({
    breadcrumbs,
}: IUseLocationStateBreadcrumbsArgs) => {
    const history = useAppHistory();

    if (!breadcrumbs) return null;

    if (history.currentState?.[ELocationStateKey.PASSED_BREADCRUMBS]) {
        const lastBreadcrumb = breadcrumbs.length ? breadcrumbs[breadcrumbs.length - 1] : undefined;
        if (!lastBreadcrumb) return breadcrumbs;
        return [
            ...history.currentState?.[ELocationStateKey.PASSED_BREADCRUMBS] ?? [],
            lastBreadcrumb,
        ];
    }

    if (history.currentState?.[ELocationStateKey.AIS_REGISTER]?.requests?.requestId) {
        const requestId = history.currentState?.[ELocationStateKey.AIS_REGISTER]?.requests?.requestId;
        return [
            {name: 'Главная страница', path: '/'},
            {name: 'Запросы', path: '/requests'},
            {name: 'Запрос на доразмещение по идентификатору документа', path: `/requests/${requestId}`},
            {name: 'Реестр документов'},
        ];
    }

    return breadcrumbs;
};
